import { Clinic } from "types/clinic";

export enum JSONSchemaServiceContentType {
    BLOG = "blog",
    CLINIC = "clinic",
    PRODUCT = "product",
}

export type JSONSchemaServiceBlogContent = {
    datePublished: string;
    imageUrl: string;
    title: string;
    description: string;
    pageUrl: string;

    dateModified?: string;
};

export type JSONSchemaServiceReviewContent = {
    authorName: string;
    datePublished: string;
    text: string;
    rating: number;
};

export type JSONSchemaServiceProductContent = {
    datePublished: string;
    imageUrl: string;
    name: string;
    description: string;
    pageUrl: string;

    reviews?: JSONSchemaServiceReviewContent[];
};

export type JSONSchemaServiceClinicContent = {
    clinicEntity: Clinic;

    image?: string;
};

export type JSONSchemaServiceProps =
    | {
          type: JSONSchemaServiceContentType.BLOG;
          content: JSONSchemaServiceBlogContent;
      }
    | {
          type: JSONSchemaServiceContentType.PRODUCT;
          content: JSONSchemaServiceProductContent;
      }
    | {
          type: JSONSchemaServiceContentType.CLINIC;
          content: JSONSchemaServiceClinicContent;
      };
